import { ProgressSpinner } from 'primereact/progressspinner'

const LoadingSpinner = () => {
  return (
    <ProgressSpinner
      style={{ width: '50px', height: '50px' }}
      strokeWidth="8"
      animationDuration=".5s"
    />
  )
}

export default LoadingSpinner
